module.exports = __webpack_public_path__ + "img/box1_icon5.27e7a90d.png";